import {LAYOUT_CONFIG} from "../../layoutConfig";

const gestalStatuses = [
    {
        value: 11,
        sec: 'Gestal',
        text: 'Gestal',
        disabled: false,
    },
    {
        value: 13,
        sec: 'ResolvedByGestal',
        text: 'ResolvedByGestal',
        disabled: false,
    },
    {
        value: 14,
        sec: 'UnresolvedByGestal',
        text: 'UnresolvedByGestal',
        disabled: false,
    }
]


export const StatsStatuses = {
    Closed: {
        value: 1,
        sec: 'Closed',
        text: 'Closed',
        disabled: true,
    },
    AllClosedResolved: {
        value: 15,
        sec: 'AllClosedResolved',
        text: 'AllClosedResolved',
        disabled: true,
    },
    AllClosedUnresolved: {
        value: 16,
        sec: 'AllClosedResolved',
        text: 'AllClosedResolved',
        disabled: true,
    },
} 

export const reportStatusesForStats = [
    {
        value: 1,
        sec: 'Closed',
        text: 'Closed',
        disabled: true,
    },
    {
        value: 15,
        sec: 'AllClosedResolved',
        text: 'AllClosedResolved',
        disabled: true,
    },
    {
        value: 16,
        sec: 'AllClosedUnresolved',
        text: 'AllClosedUnresolved',
        disabled: true,
    },
]

export const complainStatuses = [
    {
        value: 0,
        sec: 'Open',
        text: 'open',
        disabled: false,
    },
    {
        value: 3,
        sec: 'Draft',
        text: 'draft',
        disabled: true,
    },
    {
        value: 4,
        sec: 'Closed Resolved',
        text: 'closed_resolved',
        disabled: false,
    },
    {
        value: 5,
        sec: 'Closed Unresolved',
        text: 'closed_unresolved',
        disabled: false,
    },
    {
        value: 7,
        sec: 'Closed Automatically',
        text: 'closed_automatically',
        disabled: true,
    },
    {
        value: 8,
        sec: 'Closed Automatically Successfully',
        text: 'closed_automatically_resolved',
        disabled: true,
    },
    {
        value: 9,
        sec: 'Closed Automatically Unsuccessfully',
        text: 'closed_automatically_unresolved',
        disabled: true,
    },
    {
        value: 6,
        sec: 'Undelivered',
        text: 'undeliveredEmailStatusText',
        disabled: false,
    },
    {
        value: 1,
        sec: 'Closed',
        text: 'Closed',
        disabled: true,
    },
    ...(LAYOUT_CONFIG.USE_GESTAL ? gestalStatuses : []),
];



export const complainMinStatuses = [
    {
        value: 0,
        sec: 'Open',
        text: 'open',
        disabled: false,
        disabledAfterTransfer: true,
    },
    {
        value: 1,
        sec: 'Resolved by Gestal',
        text: 'resolvedBy',
        disabled: true,
    },
    {
        value: 2,
        sec: 'Transferred to CA',
        text: 'transferredToCa',
        disabled: true,
    },
    {
        value: 3,
        sec: 'Draft',
        text: 'draft',
        disabled: true,
        disabledAfterTransfer: true,
    },
    {
        value: 4,
        sec: 'Closed Resolved',
        text: 'closed_resolved',
        disabled: false,
        disabledAfterTransfer: false,
    },
    {
        value: 5,
        sec: 'Closed Unresolved',
        text: 'closed_unresolved',
        disabled: false,
        disabledAfterTransfer: false,
    },
    {
        value: 7,
        sec: 'Closed Automatically',
        text: 'closed_automatically',
        disabled: true,
        disabledAfterTransfer: true,
    },
    {
        value: 8,
        sec: 'Closed automatically successfully',
        text: 'closed_automatically_successfully',
        disabled: true,
        disabledAfterTransfer: true,
    },
    {
        value: 9,
        sec: 'Closed automatically unsuccessfully',
        text: 'closed_automatically_unsuccessfully',
        disabled: true,
        disabledAfterTransfer: true,
    },
];